import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-refresh\"><path d=\"M8.102.459 6.614 2.033c1.94.262 3.493 1.901 3.493 3.869 0 1.901-1.423 3.54-3.299 3.868L5.45 11.148h.582c2.975 0 5.368-2.361 5.368-5.246 0-1.968-1.164-3.738-2.78-4.59V0l-.518.459ZM6.679.721c-.194 0-.453-.065-.711-.065C2.993.656.6 3.016.6 5.902c0 1.967 1.164 3.737 2.78 4.59V12l.842-.852 1.293-1.312a3.96 3.96 0 0 1-3.557-3.934c0-1.968 1.488-3.607 3.428-3.87L6.679.723Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol